import React from 'react';
import UiUxIcon from '../svg/uiux.svg';

const IconUIUX = () => (
  <img src={UiUxIcon} alt="UI/UX Icon" width={76} height={76} style={{ margin: '-6px 0' }} />
);

export default IconUIUX;
